<template>
  <div
    class="sj-tab-pane"
    :class="{ border }"
    v-if="!lazy || loaded || active"
    v-show="active"
  >
    <slot></slot>
  </div>
</template>

<script>
/**
 * tabPane组件，tab的详细内容
 * 一次只显示一个
 */
export default {
  name: "SjTabPane",
  props: {
    label: {
      type: String,
      default: ""
    },
    name: {
      type: [String, Number],
      default: ""
    },
    lazy: {
      type: Boolean,
      default: false
    },
    border: {
      type: Boolean,
      default: false
    },
    self_editable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      index: null,
      loaded: false
    };
  },
  computed: {
    /**
     * 根据父组件(tab)的当前选中状态确定哪一个pane时需要显示的
     */
    active() {
      const active = this.$parent.currentName === (this.name || this.index);
      if (active) {
        // eslint-disable-next-line
        this.loaded = true;
      }
      return active;
    },
    paneName() {
      return this.name || this.index;
    }
  },
  mounted() {
    this.$parent.addPanes(this);
  },
  destroyed() {
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
    this.$parent.removePanes(this);
  },
  updated() {
    this.$parent.refresh();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
@import "./index";

.sj-tab-pane {
  flex: 1;
  min-height: 0;
  overflow: auto;
  background-color: @tab-pane-background-color;

  &.border {
    border: @--border-width-base @--border-style-base @--tab-border-color;
    border-top: none;
  }
}
</style>
